import React from "react";
import Search from "./Search";

export default function ReserveForRepairList() {
  return <Search />;
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/ReserveForRepair/ReservedForRepairList.jsx